import React from 'react';
import { Input } from '@chargify/custom-ui-components';
import FilterBox, { FilterBoxProps } from '../FilterBox';

export interface InvoiceNumberFilterProps
  extends Omit<FilterBoxProps, 'children'> {
  onChange: (value: string) => void;
  placeholder?: string;
  value?: string;
}

export const InvoiceNumberFilter = ({
  onChange,
  placeholder,
  value,
  ...rest
}: InvoiceNumberFilterProps) => {
  return (
    <FilterBox {...rest}>
      <Input
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        iconRight={'search'}
        value={value}
        inputSize={'small'}
      />
    </FilterBox>
  );
};
